import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
    <footer className="bg-blue-900 text-white py-8 mt-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 border-b border-gray-700 pb-8">
                
                {/* 1. Left Section - Company Info */}
                <div className="flex flex-col space-y-3">
                    <h3 className="text-2xl font-bold text-white mb-2">Anveshana E-Paper</h3>
                    <p className="text-gray-300 text-sm">Your daily Telugu newspaper in digital format. Committed to delivering timely and reliable news across the region.</p>
                </div>

                {/* 2. Middle Section - Quick Links */}
                <div>
                    <h4 className="text-lg font-semibold text-white mb-4 border-b border-blue-600 inline-block pb-1">Quick Links</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/" className="hover:text-blue-400 transition-colors">Home</Link></li>
                        {/* Placeholder links for non-routed pages */}
                        <li><a href="#about" className="hover:text-blue-400 transition-colors">About</a></li>
                        <li><a href="#epaper" className="hover:text-blue-400 transition-colors">E-Paper</a></li>
                        <li><a href="#contact" className="hover:text-blue-400 transition-colors">Contact</a></li>
                    </ul>
                </div>

                {/* 3. Right Section - Contact Us */}
                <div>
                    <h4 className="text-lg font-semibold text-white mb-4 border-b border-blue-600 inline-block pb-1">Contact Us</h4>
                    <p className="space-y-2 flex flex-col text-sm">
                        <span>Email: <a href="mailto:info@anveshana.com" className="text-blue-200 hover:text-blue-300 transition-colors">info@anveshana.com</a></span>
                        <span>Phone: <a href="tel:+919949286410" className="text-blue-200 hover:text-blue-300 transition-colors">+91 9949286410</a></span>
                    </p>
                </div>

            </div>

            {/* Bottom Section - Copyright */}
            <div className="mt-6 pt-4 text-center text-sm text-500">
                <p>© {new Date().getFullYear()} Anveshana. All rights reserved.</p>
            </div>
        </div>
    </footer>
);

export default Footer;